export default {
  title: 'Produtos de impressão personalizados',
  fields: {
    name: 'Nome',
    format: 'Tipo de produto',
  },
  buttons: {
    upload_product: 'Iniciar processo de envio',
    preview: 'Pré-visualização',
    edit: 'Editar',
  },
};
